// Single source for Ranked crest artwork (8 distinct tiers) + live numeral anchoring.
export const CREST_VERSION = 'kickard-rank-crests-v2';

const art = (tier) => `/kickard/rank-${tier}.webp?v=${CREST_VERSION}`;

export const TIER_ART = {
  bronze: art('bronze'),
  silver: art('silver'),
  gold: art('gold'),
  platinum: art('platinum'),
  diamond: art('diamond'),
  master: art('master'),
  champion: art('champion'),
  legend: art('legend'),
};

// Optical centre of each shield's inner face, in % of the 512x512 canvas
// (measured from the alpha silhouette + frame geometry, not the canvas centre).
export const CREST_FACE = {
  bronze: { x: 49.7, y: 55 },
  silver: { x: 49.9, y: 55 },
  gold: { x: 49.6, y: 55 },
  platinum: { x: 49.7, y: 56 },
  diamond: { x: 49.7, y: 57 },
  master: { x: 49.8, y: 57 },
  champion: { x: 50.1, y: 57 },
  legend: { x: 48.7, y: 57 },
};

// Inline style that pins a numeral span (any existing class) to the shield face.
export function crestNumeralStyle(tier) {
  const f = CREST_FACE[tier] || { x: 50, y: 55 };
  return {
    position: 'absolute', inset: 'auto', left: `${f.x}%`, top: `${f.y}%`,
    transform: 'translate(-50%, -50%)', display: 'block', lineHeight: 1, whiteSpace: 'nowrap',
  };
}

// Placement / unranked placeholder: grey, inactive silhouette (never reads as Gold).
export const CREST_PLACEHOLDER_STYLE = { opacity: 0.4, filter: 'grayscale(1) brightness(0.85)' };
